import { render } from "./IngresoPreguntas2.vue?vue&type=template&id=12e30692&scoped=true"
import script from "./IngresoPreguntas2.vue?vue&type=script&lang=js"
export * from "./IngresoPreguntas2.vue?vue&type=script&lang=js"

import "./IngresoPreguntas2.vue?vue&type=style&index=0&id=12e30692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e30692"]])

export default __exports__